module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAdElEQVQoU5WRbQ2AIBgG72lgBCMYxQhGMIIRjGAEIxjBRo+DIWOM+cEPNrbjuL2IH0s/WD7BtifgeIUTiKTtES7BkCvbPTBI2sv+Goxw2GzPsUk60zk0xqdLQc6wvQArMLbAbE62DggXztp421+n0cz48jkXWJQnKSKOn3YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gou.png
// module id = oXH0
// module chunks = 1